import React, { useState } from "react";
import ChartContext from "./context/ChartContext";

const WrapperComponent = ({ children }) => {
  const [exportGanttChart, setExportGanttChart] = useState(() => () => {});

  return (
    <ChartContext.Provider value={{ exportGanttChart, setExportGanttChart }}>
      <div>
        {children}
      </div>
    </ChartContext.Provider>
  );
};

export default WrapperComponent;
